import { render, staticRenderFns } from "./contrat-card.vue?vue&type=template&id=1ed47cf9&scoped=true"
import script from "./contrat-card.vue?vue&type=script&lang=js"
export * from "./contrat-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed47cf9",
  null
  
)

export default component.exports